import React from 'react';

function Edit() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="green" xmlns="http://www.w3.org/2000/svg" className="pencil">
      <path
        d="M18.0309 1.3311C19.3331 2.63324 19.3331 4.74444 18.0309 6.04658L6.87894 17.1986C6.62095 17.4566 6.3001 17.6427 5.9481 17.7387L1.18134 19.0388C0.659659 19.1811 0.18097 18.7024 0.323248 18.1807L1.62327 13.4139C1.71927 13.0619 1.90547 12.7411 2.16346 12.4831L13.3154 1.3311C14.6176 0.0289562 16.7288 0.0289562 18.0309 1.3311ZM12.4121 4.21118L3.15177 13.4714C3.06578 13.5574 3.00371 13.6643 2.97171 13.7817L1.99347 17.3685L5.58034 16.3903C5.69768 16.3583 5.80463 16.2962 5.89062 16.2102L15.1506 6.94971L12.4121 4.21118ZM14.3038 2.31941L13.3998 3.22255L16.1383 5.96201L17.0426 5.05827C17.7989 4.30195 17.7989 3.07573 17.0426 2.31941C16.2863 1.5631 15.0601 1.5631 14.3038 2.31941Z"
        fill="#168884"
      ></path>
    </svg>
  );
}

export default Edit;
